<template>
  <div class="body LKLayout w-mod-js w-mod-touch w-mod-ix">
    <div
      class="screen"
      :class="{
        'mod--nav': !hidden,
      }"
    >
      <slot name="header" />
      <div class="footer__dec-gb" />
    </div>

    <div class="screen">
      <div class="content">
        <slot name="before-content" />

        <div class="content__main">
          <div v-if="$scopedSlots.aside" class="main__aside-mask">
            <slot name="aside" />
          </div>

          <div class="main__container LKLayout__default">
            <slot />
          </div>
        </div>
      </div>
    </div>

    <div class="screen mod--footer">
      <div class="content">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LKLayout',
  props: {
    hidden: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
@import "~@/assets/scss/components/LKLayout/_LKLayout.scss";

.LKLayout {
  @include _LKLayout;

  position: relative;
  z-index: 0;
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  &__default {
    position: relative;
  }

  @media (max-width: 767px) and (min-width: 480px) {
    &.w-mod-js:not(.w-mod-ix) [data-w-id="b073d01f-c6ba-ac5b-98c4-bb7634610dda"] {
      height: 0;
    }
  }

  @media (max-width: 479px) {
    &.w-mod-js:not(.w-mod-ix) [data-w-id="b073d01f-c6ba-ac5b-98c4-bb7634610dda"] {
      height: 0;
    }
  }

  .filter__toggle__icon {
    transition: all 0.4s ease;

    &_active {
      transform: rotate(180deg);
    }
  }
}
</style>
